import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { logout } from 'api/services/apiClient';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-v7';
import { routePath } from 'rooting/routes';
import { UserRole } from 'shared';
import { LanguageSelect } from 'shared/components/LanguageSelect';
import { userStore } from 'stores/userStore/userStore';
import { StyledMenuButtonItem, StyledMenuSection } from './StyledComponents';

interface Props {
	isMenuOpen: boolean;
	handleCloseMenu: () => void;
}

export const MenuModal = ({ isMenuOpen, handleCloseMenu }: Props) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const isChainAdmin = userStore.userContext.userRole === UserRole.ChainAdmin;

	const handleLogout = () => {
		logout();
	};

	return (
		<Dialog open={isMenuOpen} onClose={handleCloseMenu} fullWidth maxWidth='sm'>
			<DialogTitle>{t('common.settings')}</DialogTitle>
			<DialogContent>
				<StyledMenuSection>
					{/* User Info */}
					<Box display='flex' justifyContent='space-between' alignItems='center'>
						<Typography variant='subtitle1' fontWeight={'fontWeightMedium'}>
							{userStore.userContext.userName}
						</Typography>
						<Button id='menu-logout-button' variant='text' color='primary' onClick={handleLogout}>
							{t('common.logout')}
						</Button>
					</Box>

					{/* Language Selector */}
					<Box display='flex' alignItems='center' gap={1}>
						<LanguageSelect />
					</Box>
				</StyledMenuSection>

				{/* Select Location */}
				{isChainAdmin && (
					<StyledMenuButtonItem
						id='menu-link-to-locations-page'
						onClick={() => navigate(routePath.locations)}
					>
						{t('pages.locations.selectLocation')}
					</StyledMenuButtonItem>
				)}
			</DialogContent>

			<DialogActions>
				<Button
					id='menu-cancel-button'
					onClick={handleCloseMenu}
					variant='outlined'
					color='primary'
					sx={{ marginRight: 2, marginBottom: 2 }}
				>
					{t('common.cancel')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
